module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-type-links/admin-type-links.component.scss
// module id = ./src/app/components/admin/admin-type-links/admin-type-links.component.scss
// module chunks = main